"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountsResponseToJSON = exports.AdAccountsResponseFromJSONTyped = exports.AdAccountsResponseFromJSON = exports.instanceOfAdAccountsResponse = void 0;
var runtime_1 = require("../runtime");
var AdAccountResponse_1 = require("./AdAccountResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the AdAccountsResponse interface.
 */
function instanceOfAdAccountsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountsResponse = instanceOfAdAccountsResponse;
function AdAccountsResponseFromJSON(json) {
    return AdAccountsResponseFromJSONTyped(json, false);
}
exports.AdAccountsResponseFromJSON = AdAccountsResponseFromJSON;
function AdAccountsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'adAccounts': !(0, runtime_1.exists)(json, 'ad_accounts') ? undefined : (json['ad_accounts'].map(AdAccountResponse_1.AdAccountResponseFromJSON)),
    };
}
exports.AdAccountsResponseFromJSONTyped = AdAccountsResponseFromJSONTyped;
function AdAccountsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'ad_accounts': value.adAccounts === undefined ? undefined : (value.adAccounts.map(AdAccountResponse_1.AdAccountResponseToJSON)),
    };
}
exports.AdAccountsResponseToJSON = AdAccountsResponseToJSON;
